// extracted by mini-css-extract-plugin
module.exports = {"rounded":"_1huOzJ"};